import React from "react";
import { FacilityOrderPatientNewFlowClinicalEditTemplate } from "themes/application/facility-order-new-flow-clinical/components";
import { observer } from "mobx-react";

@observer
class FacilityOrderPatientNewFlowClinicalEdit extends React.Component {
	render() {
		return <FacilityOrderPatientNewFlowClinicalEditTemplate {...this.props} />;
	}
}

export default FacilityOrderPatientNewFlowClinicalEdit;